import { IPurchaseCategory } from "../../types/purchaseCategory.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export interface ICategoryGroupResponse {
  id: string;
  name: string;
  referenceCode: string;
}

type GetCategoriesOptions = {
  status?: string[];
  search?: string;
  page?: number;
  itemsPerPage?: string;
  orderBy?: string;
  fields?: string;
};

export type Category = {
  name: string;
  type: string;
  categoryGroupId: string;
};

export async function createCategory(data) {
  const url = `${API_URL}/purchase-category`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IPurchaseCategory>
  >;

  return result;
}

export async function getCategoryGroups() {
  const url = `${API_URL}/purchase-category/groups`;
  return (await makeRequestDebounced(url)) as ApiResponseType<
    ICategoryGroupResponse[]
  >;
}

export async function getCategoryById(id: string) {
  const url = `${API_URL}/purchase-category/${id}`;
  return (await makeRequestDebounced(
    url
  )) as ApiResponseType<IPurchaseCategory>;
}

export async function getCategories(options: GetCategoriesOptions = {}) {
  const {
    status = [],
    search = "",
    page = 1,
    itemsPerPage = "10",
    orderBy = "updatedAt",
    fields = "name,type,idNibo",
  } = options;
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/purchase-category?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IPurchaseCategory[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function getAllCategories() {
  const params = new URLSearchParams();
  const url = `${API_URL}/purchase-category?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IPurchaseCategory[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}
